import { render, staticRenderFns } from "./_reportTasksRibbon.vue?vue&type=template&id=40dd2a18"
import script from "./_reportTasksRibbon.vue?vue&type=script&lang=js"
export * from "./_reportTasksRibbon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports